(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5074],{

/***/ 64577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ AspectRatio; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/AspectRatio/AspectRatio.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((_theme, { ratio }) => ({
  root: {
    position: "relative",
    maxWidth: "100%",
    "&::before": {
      content: '""',
      height: 0,
      display: "block",
      paddingBottom: `${1 / ratio * 100}%`
    },
    "&::after": {
      content: '""',
      display: "table",
      clear: "both"
    },
    "& > *:not(style)": {
      overflow: "hidden",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%"
    },
    "& > img, & > video": {
      objectFit: "cover"
    }
  }
}));

/* harmony default export */ var AspectRatio_styles = (useStyles);
//# sourceMappingURL=AspectRatio.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/AspectRatio/AspectRatio.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AspectRatio = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("AspectRatio", {}, props), { className, ratio, children, unstyled } = _a, others = __objRest(_a, ["className", "ratio", "children", "unstyled"]);
  const { classes, cx } = AspectRatio_styles({ ratio }, { name: "AspectRatio", unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    ref,
    className: cx(classes.root, className)
  }, others), children);
});
AspectRatio.displayName = "@mantine/core/AspectRatio";


//# sourceMappingURL=AspectRatio.js.map


/***/ }),

/***/ 38836:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noi-dia",
      function () {
        return __webpack_require__(28394);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ NoiDia; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./apis/queryFunctions/ecompagesFunctions.js
var ecompagesFunctions = __webpack_require__(4088);
// EXTERNAL MODULE: ./common/components/DefaultSEO.js
var DefaultSEO = __webpack_require__(51623);
// EXTERNAL MODULE: ./common/components/HomeNews.js
var HomeNews = __webpack_require__(85654);
// EXTERNAL MODULE: ./common/components/PageContainer.js
var PageContainer = __webpack_require__(41291);
// EXTERNAL MODULE: ./utils/appendImageUrlFromAPI.js
var appendImageUrlFromAPI = __webpack_require__(22312);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(38623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./public/HeadOfPage.png
var HeadOfPage = __webpack_require__(82245);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(54777);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(62679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/AspectRatio/AspectRatio.js + 1 modules
var AspectRatio = __webpack_require__(64577);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 114 modules
var motion = __webpack_require__(2020);
// EXTERNAL MODULE: ./common/Typography/TitleCus.js
var TitleCus = __webpack_require__(95197);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./setup/locale-provider/index.js
var locale_provider = __webpack_require__(59963);
// EXTERNAL MODULE: ./utils/sanitizeDOMData.js
var sanitizeDOMData = __webpack_require__(60959);
;// CONCATENATED MODULE: ./pages/noi-dia/components/Info.js













function Info(param) {
    var _title = param.title, title = _title === void 0 ? "Why to choose" : _title, label = param.label, _picture = param.picture, picture = _picture === void 0 ? "https://zengroup.com.vn/wp-content/uploads/2022/04/du-an-nha-mat-tien-Q12-1024x768.jpg" : _picture, index = param.index;
    var ref, ref1, ref2;
    var link = picture || null;
    if (link != null) {
        if (link && link.indexOf("http") < 0) {
            link = "".concat("https://api.flexzen.app").concat(link, "?access_token=").concat("flex.public.token", "&trustkey=").concat("APP.FKJSHHHH908KJF");
        }
    }
    var isTablet = (0,useWindowSize/* default */.Z)().isTablet;
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    var locale = (0,router.useRouter)().locale;
    var data = (0,ecompagesFunctions/* useFetchEcompage */.VM)("trang-noi-dia-viet-thien", locale).data;
    var infoNoidia = ((data === null || data === void 0 ? void 0 : data.add_on_data) || []).slice(0, 5);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        component: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                sx: {
                    paddingBottom: "20px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                        my: "xs",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            order: 1,
                            size: isTablet ? 24 : 36,
                            weight: 950,
                            align: "center",
                            pb: 10,
                            sx: function(theme) {
                                return {
                                    color: "#12854F" /* theme.colors.main[5] */ 
                                };
                            },
                            children: (0,sanitizeDOMData/* default */.Z)(infoNoidia === null || infoNoidia === void 0 ? void 0 : (ref = infoNoidia[0]) === null || ref === void 0 ? void 0 : ref.title)
                        }),
                        labelPosition: "center"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                        justify: "space-between",
                        align: "center",
                        children: infoNoidia.slice(1, 4).map(function(info, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 12,
                                md: 3,
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                    whileHover: {
                                        scale: 1.05
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: (0,appendImageUrlFromAPI/* default */.Z)({
                                                    src: info === null || info === void 0 ? void 0 : info.picture,
                                                    size: "l"
                                                }),
                                                alt: "".concat(info === null || info === void 0 ? void 0 : info.title),
                                                width: 128,
                                                height: 128
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: 36,
                                                        weight: 950,
                                                        style: {},
                                                        children: (0,sanitizeDOMData/* default */.Z)(info.title)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: 24,
                                                        weight: 450,
                                                        children: (0,sanitizeDOMData/* default */.Z)(info === null || info === void 0 ? void 0 : info.content)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                sx: {
                    paddingBottom: "20px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                        my: "xs",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: 36,
                            weight: 950,
                            align: "center",
                            pb: 10,
                            sx: function(theme) {
                                return {
                                    color: "#12854F" /* theme.colors.main[5] */ 
                                };
                            },
                            children: (0,sanitizeDOMData/* default */.Z)(infoNoidia === null || infoNoidia === void 0 ? void 0 : (ref1 = infoNoidia[4]) === null || ref1 === void 0 ? void 0 : ref1.title)
                        }),
                        labelPosition: "center"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        sx: {
                            padding: "30px 0 30px 0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectRatio/* AspectRatio */.o, {
                            ratio: 16 / 9,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15672.58745657534!2d106.66630370413816!3d10.876432277921307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3175293ed8e2cfbb%3A0xa54be615e08688f6!2zTsOUTkcgU-G6ok4gVknhu4ZUIFRIScOKTg!5e0!3m2!1sen!2s!4v1688366521053!5m2!1sen!2s",
                                title: "Google map",
                                frameBorder: "0"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        size: 18,
                        style: {
                            lineHeight: "40px"
                        },
                        align: "justify",
                        children: (0,sanitizeDOMData/* default */.Z)(infoNoidia === null || infoNoidia === void 0 ? void 0 : (ref2 = infoNoidia[4]) === null || ref2 === void 0 ? void 0 : ref2.content)
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/noi-dia/index.page.js
/* eslint-disable react/no-array-index-key */ 











var __N_SSG = true;
function NoiDia(param) {
    var dataSEO = param.dataSEO;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,ecompagesFunctions/* useFetchEcompage */.VM)("trang-noi-dia-viet-thien", locale), detail = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultSEO/* default */.Z, {
                seo: dataSEO
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton/* Skeleton */.O, {
                        visible: !detail,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                sx: {
                                    position: "relative",
                                    width: "100%",
                                    aspectRatio: "2.55"
                                },
                                children: Boolean(detail) && (detail === null || detail === void 0 ? void 0 : detail.picture) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: (0,appendImageUrlFromAPI/* default */.Z)({
                                        src: detail === null || detail === void 0 ? void 0 : detail.picture,
                                        size: "xl"
                                    }),
                                    alt: detail === null || detail === void 0 ? void 0 : detail.title,
                                    layout: "fill",
                                    priority: true,
                                    quality: 100
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                sx: {
                                    objectPosition: "bottom",
                                    marginTop: "-5%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: HeadOfPage/* default */.Z,
                                    alt: "paint",
                                    objectFit: "cover"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        pos: "relative",
                        sx: {
                            paddingBottom: "100px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                            sx: {
                                zIndex: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContainer/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                    size: "xl",
                                    sx: {
                                        background: "#F8F8F8",
                                        padding: "1px 0 70px 0"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNews/* default */.Z, {})
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3987,296,5907,9774,2888,179], function() { return __webpack_exec__(38836); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);